import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "p-col-12" }
const _hoisted_7 = { class: "p-field p-col-6" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Card = _resolveComponent("Card")
  const _component_ScorecardsTable = _resolveComponent("ScorecardsTable")
  const _component_KnPerspectiveCard = _resolveComponent("KnPerspectiveCard")

  return (_openBlock(), _createBlock("div", {
    class: "p-d-flex kn-flex",
    style: _ctx.descriptor.style.mainDialog
  }, [
    _createVNode("div", {
      class: "kn-list--column",
      style: _ctx.descriptor.style.designer
    }, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.scorecards.scorecardDesigner')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "kn-button p-button-text",
            disabled: _ctx.saveButtonDisabled,
            onClick: _ctx.saveScorecard
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_Button, {
            class: "kn-button p-button-text",
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      (_ctx.scorecard)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 0,
            class: "p-m-2"
          }, {
            content: _withCtx(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("span", _hoisted_3, [
                    _createVNode(_component_InputText, {
                      class: ["kn-material-input", {
                                        'p-invalid': !_ctx.scorecard.name && _ctx.nameTouched
                                    }],
                      modelValue: _ctx.scorecard.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.scorecard.name = $event)),
                      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.touched = true))
                    }, null, 8, ["modelValue", "class"]),
                    _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name') + ' *'), 1)
                  ]),
                  (!_ctx.scorecard.name && _ctx.nameTouched)
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _createVNode("small", _hoisted_6, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('documentExecution.olap.crossNavigationDefinition.parameterName') })), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, [
                    _createVNode(_component_InputText, {
                      class: "kn-material-input",
                      modelValue: _ctx.scorecard.description,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.scorecard.description = $event)),
                      onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.touched = true))
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('common.description')), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.scorecard)
        ? (_openBlock(), _createBlock(_component_ScorecardsTable, {
            key: 1,
            propScorecard: _ctx.scorecard,
            criterias: _ctx.criterias,
            kpis: _ctx.kpis,
            onTouched: _cache[5] || (_cache[5] = ($event: any) => (_ctx.touched = true))
          }, null, 8, ["propScorecard", "criterias", "kpis"]))
        : _createCommentVNode("", true)
    ], 4),
    (_ctx.scorecard)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          id: "sideMenu",
          class: "kn-overflow",
          style: _ctx.descriptor.style.perspective
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scorecard.perspectives, (perspective, index) => {
            return (_openBlock(), _createBlock(_component_KnPerspectiveCard, {
              class: "p-m-4",
              key: index,
              propPerspective: perspective,
              "data-test": 'perspective-' + perspective.name
            }, null, 8, ["propPerspective", "data-test"]))
          }), 128))
        ], 4))
      : _createCommentVNode("", true)
  ], 4))
}